import { useEffect, useState } from "react";
import moment from "moment";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { generateAxiosInstanceInstitute } from "../../hooks/useAuthorizedRequestForInstitute";
import { generateAxiosInstanceSection } from "../../hooks/useAuthorizedRequestForSection";
import { useNavigate } from 'react-router-dom';
import { getCurrentTime } from "../../components/CurrentTime";
import { LocalizationProvider, DatePicker, MonthCalendar } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from "@mui/material";
import { ImageModal, Loader } from "../../components/ModalsCommonFunctions";
import Swal from "sweetalert2";
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";
import { findPageNumber, searchArray } from "../../components/Navigation";
import ViewImageAndText from "../../components/ViewImageAndText";
import Pagination from "../../components/Pagination";
import { copyTestFormValidation } from "../../validation/Validation";
import { ErrorMessage } from "../../validation/validationError";
import { ZodError } from "zod";

const TestCopier = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute();
    const authorizedAxiosSection = generateAxiosInstanceSection();
    const instituteMasterId = localStorage.getItem("instituteMasterId");
    let sectionMasterId = localStorage.getItem("sectionMasterId");
    const inititalFormState = {
        instituteMasterId,
        section_id: sectionMasterId,
        class_id: '',
        month: moment().format('YYYY-MM'),
        examMasterId: "",
        reNameTest: ""
    }

    const [testCopyData, setTestCopyData] = useState(inititalFormState);
    const [gradeList, setGradeList] = useState([]);
    const [examList, setExamList] = useState([]);
    const [questionList, setQuestionList] = useState([]);

    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(false);

    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];

    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getGradeList();
    }, []);

    useEffect(() => {
        getExamList();
    }, [testCopyData.class_id, testCopyData.month]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getQuestionList(testCopyData.examMasterId);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (testCopyData.syllabusStructureMasterId !== "" && testCopyData.subjectMasterId !== "") {
                setQuestionList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questionList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(questionList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questionList.length) {
            endIndex = questionList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questionList.slice(startIndex, endIndex));
    }, [questionList, currPage, itemsPerPage]);


    const getGradeList = () => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                setGradeList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getExamList = () => {
        setTestCopyData(prevData => ({
            ...prevData,
            examMasterId: ""
        }));

        const apiUrl = `/institute-exam-masters?instituteMasterId=${testCopyData.instituteMasterId}&class_id=${testCopyData.class_id}&month=${testCopyData.month}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setExamList(response.data.result);
            })
            .catch(error => {
                setExamList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTestCopyData((prevData) => {
            return {
                ...prevData,
                [name]: value,
            }
        })

        if (value.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const getQuestionList = (examMasterId) => {
        const apiUrl = `/exam-manual-questions/${examMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setQuestionList(response.data.questions);
            })
            .catch(error => {
                setQuestionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTestChange = (e) => {
        const { name, value, selectedOptions } = e.target;
        const exam_type = selectedOptions[0].getAttribute("data-exam-type");
        setTestCopyData((prevData) => {
            return {
                ...prevData,
                [name]: value,
            }
        })

        if (exam_type == "" || exam_type == "M" || exam_type == "R") {
            getQuestionList(value);
        } else {
            Swal.fire({ text: "This exam is not available to copy" });
        }

        if (value.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleMonth = (newMonth) => {
        setTestCopyData((prevData) => ({
            ...prevData,
            month: newMonth ? newMonth.format('YYYY-MM') : '',
        }));

        if (newMonth.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== "month"));
        }
    };

    const copyTest = async () => {
        try {
            await copyTestFormValidation.parseAsync(testCopyData);
            setError([]);
            setLoading(true);
            let apiUrl = `/copy-test`;
            const response = await authorizedAxiosSection.post(apiUrl, testCopyData);
            setQuestionList([]);
            setTestCopyData(inititalFormState);
            Swal.fire({ text: response.data.message });
        } catch (error) {
            // const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            // Swal.fire({ text: errorMsg });
            if (error instanceof ZodError) {
                setError(error.errors);
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setTestCopyData(inititalFormState);
        // setExamList([]);
        setQuestionList([]);
        setError([]);
    }


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>

                        <li className="breadcrumb-item active"><span>Test Copier</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i>Test Copier</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class:</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleInputChange} value={testCopyData.class_id} >
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="class_id" />
                                                </div>

                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>From Date: </label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(testCopyData.month)}
                                                            onChange={handleMonth} // Use the month picker handler here
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    <ErrorMessage errors={error} field="month" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Test:</label>
                                                    <select class="form-select" aria-label="Default select example" name='examMasterId' onChange={handleTestChange} value={testCopyData.examMasterId} >
                                                        <option selected value={''} disabled>Select Test</option>
                                                        {
                                                            examList?.filter(exam => exam.exam_type != null).map((exam) => {
                                                                return <option value={exam.id} data-exam-type={exam.exam_type}>{exam.exam_name}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="examMasterId" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="reNameTest" className="col-form-label"><span style={{ color: "red" }}>*</span>Re-Name Test:</label>
                                                    <input type="text" className="form-control" name="reNameTest" value={testCopyData.reNameTest} onChange={handleInputChange} />
                                                    <ErrorMessage errors={error} field="reNameTest" />
                                                </div>
                                            </div>

                                            <div className="row">

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-primary" type="button" onClick={copyTest}>Copy</button>
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div className='tab-content rounded-bottom custom_table custom_table_width'>
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className="text-center">Sr. No.</th>
                                                                        <th scope="col">Subject Name</th>
                                                                        <th scope="col">Lesson Name</th>
                                                                        <th scope="col">Q_Level</th>
                                                                        <th scope="col">Q_Type</th>
                                                                        <th scope="col">Question</th>
                                                                        <th scope="col">Option A</th>
                                                                        <th scope="col">Option B</th>
                                                                        <th scope="col">Option C</th>
                                                                        <th scope="col">Option D</th>
                                                                        <th scope="col">Ans</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((question, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{question.subjectName}</td>
                                                                                        <td>{question.lessonName}</td>
                                                                                        <td>{question.q_level}</td>
                                                                                        <td>{question.q_type}</td>
                                                                                        <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                        <td>{question.ans}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questionList.length} />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}
        </>
    )
};

export default TestCopier;